module.exports = __webpack_public_path__ + "static/media/dog.f0ad6ad5.jpeg";